// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarRectangle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-rectangle': IconCalendarRectangle;
    }
}

/**
 * The icon component for the 'calendarRectangle' icon
 */
export class IconCalendarRectangle extends IconSvg {
    public constructor() {
        super(calendarRectangle16X16);
    }
}

registerIconSvg('icon-calendar-rectangle', IconCalendarRectangle);
export const iconCalendarRectangleTag = 'nimble-icon-calendar-rectangle';
